<template>
	<el-dialog v-model="props.Kefu_dialog_flag" title="" width="300" @close="handleClose"  modal-z-index="2000" z-index="10000"   >
		<div>
			<p style="margin-bottom: 10px;">客服微信</p>
			<img :src="`${store.state.request_url}`+'/img/kefu.png'" width="200" height="200" />
			<p style="margin-top: 20px;">QQ群:<span style="font-weight: 900;">831907452</span></p>
		</div>
	</el-dialog>
</template>

<script setup>
	import {
		reactive,
		onMounted,
		computed,
		defineProps,
	} from 'vue'
	import {
		ElMessage
	} from 'element-plus';
	import {
		useStore
	} from 'vuex';
	const store = useStore();
	const props = defineProps({
		Kefu_dialog_flag: {
			type: Boolean,
			default: false
		}
	})
	// 定义 emits 向父组件发送事件
	const emit = defineEmits(['update:Kefu_dialog_flag','close'])
	// 使用计算属性来管理弹窗显示状态
	const dialogVisible = computed({
		get: () => props.Kefu_dialog_flag,
		set: (value) => {
			emit('update:Kefu_dialog_flag', value)
		}
	})
	const state = reactive({})
	const handleClose = () => {
		emit('close')
	}
</script>

<style lang="less">

</style>